"use client";

import { useEffect, useState } from "react";
import { helperPing } from "../lib/helper-client";

export function HelperFallbackBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    void helperPing().then((ok) => setShow(!ok));
  }, []);

  if (!show) return null;
  return (
    <div
      style={{
        background: "#141414",
        color: "#d4af37",
        padding: "8px 16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: 13,
      }}
    >
      <span>Helper 미설치. 100 MB 이상 파일은 Helper로 빠르게 처리할 수 있습니다.</span>
      <a
        href="https://helper-releases.makemonlab.studio"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#d4af37", textDecoration: "underline" }}
      >
        Helper 설치하기 →
      </a>
    </div>
  );
}
